import React, { FC, useState } from 'react'

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@components/ui/sheet'
import {
  Bookmark,
  Forward,
  Heart,
  MessageCircleMore,
  Share,
} from 'lucide-react'

const FeedItem: FC = () => {
  const [commentsOpen, setCommentsOpen] = useState<boolean>(false)

  return (
    <>
      <div className="aspect-[9/16] h-full mx-auto relative h-full-w-full pb-24">
        <div className="relative rounded w-full h-full">
          <video
            src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4"
            className="h-full w-full object-cover absolute rounded-lg"
            autoPlay
            loop
            muted
          />
        </div>
        <div className="grid grid-cols-1 gap-4 absolute right-4 bottom-32 bg-black bg-opacity-15 p-4 rounded">
          <Heart className="w-8 h-8" fill="white" strokeWidth={0} />
          <MessageCircleMore
            className="w-8 h-8 text-white"
            onClick={() => setCommentsOpen(true)}
          />
          <Bookmark className="w-8 h-8" fill="white" strokeWidth={0} />
          <Share className="w-8 h-8 text-white" />
        </div>
      </div>
      <Sheet open={commentsOpen} onOpenChange={setCommentsOpen}>
        <SheetContent>
          <SheetHeader>
            <SheetTitle>Comments</SheetTitle>
          </SheetHeader>
        </SheetContent>
      </Sheet>
    </>
  )
}

export default FeedItem
